(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vr-flow-guide"]) return;
  try {
    
 document.addEventListener('click', async function(event) {
   var button=event.target.closest('[data-flow-copy]');if(!button)return;
   var field=button.closest('details').querySelector('input');
   try{await navigator.clipboard.writeText(field.value);button.textContent=button.dataset.copied;}catch(error){field.focus();field.select();button.textContent=button.dataset.fallback;}
 });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vr-product-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const modeFor = section => {
      if (location.hash === '#product-reviews' || location.hash === '#judgeme_product_reviews') return 'product';
      if (location.hash === '#shop-reviews') return 'shop';
      return section.dataset.reviewDefault || 'product';
    };
    const selectView = (section, mode) => {
      const tab = section.querySelector(mode === 'shop' ? '#jdgm-tab_shop_reviews' : '#jdgm-tab_product_reviews');
      if (!tab) return false;
      if (tab.getAttribute('aria-selected') !== 'true') tab.click();
      return tab.getAttribute('aria-selected') === 'true';
    };
    const initialize = () => {
      const section = document.getElementById('product-reviews');
      if (!section || section.dataset.vrReviewRouting) return;
      section.dataset.vrReviewRouting = 'true';
      const ready = () => selectView(section, modeFor(section));
      if (ready()) return;
      const observer = new MutationObserver(() => { if (ready()) observer.disconnect(); });
      observer.observe(section, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-selected'] });
    };
    document.addEventListener('click', event => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('a[data-vr-review-view]');
      const section = document.getElementById('product-reviews');
      if (!link || !section) return;
      event.preventDefault();
      const mode = link.dataset.vrReviewView;
      history.pushState(null, '', mode === 'shop' ? '#shop-reviews' : '#product-reviews');
      selectView(section, mode);
      requestAnimationFrame(() => {
        section.focus({ preventScroll: true });
        section.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      });
    });
    window.addEventListener('hashchange', () => {
      const section = document.getElementById('product-reviews');
      if (section) selectView(section, modeFor(section));
    });
    initialize();
    document.addEventListener('shopify:section:load', initialize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vr-promotion-banner"] && !Shopify.designMode) return;
  try {
    
  function updateVitaRenewPromotions(){
    document.querySelectorAll('[data-vr-promotion-end]').forEach(banner=>{
      if(banner.dataset.vrPromotionTimer)clearTimeout(Number(banner.dataset.vrPromotionTimer));
      const remaining=Number(banner.dataset.vrPromotionEnd)*1000-Date.now();
      if(!Number.isFinite(remaining)||remaining<=0){banner.remove();return;}
      const countdown=banner.querySelector('[data-vr-countdown]');
      if(countdown){
        const totalSeconds=Math.ceil(remaining/1000);
        const values={days:Math.floor(totalSeconds/86400),hours:Math.floor(totalSeconds%86400/3600),minutes:Math.floor(totalSeconds%3600/60),seconds:totalSeconds%60};
        Object.entries(values).forEach(([part,value])=>{countdown.querySelector(`[data-vr-${part}]`).textContent=String(value).padStart(2,'0')});
        const toggle=banner.querySelector('[data-vr-countdown-toggle]');
        if(!banner.dataset.vrCountdownInitialized){
          banner.dataset.vrCountdownInitialized='true';
          countdown.hidden=false;
          if(toggle){
            toggle.hidden=false;
            toggle.addEventListener('click',()=>{
              countdown.hidden=!countdown.hidden;
              const label=countdown.hidden?toggle.dataset.labelShow:toggle.dataset.labelHide;
              toggle.setAttribute('aria-expanded',String(!countdown.hidden));
              toggle.setAttribute('aria-label',label);
              toggle.setAttribute('title',label);
              toggle.querySelector('span').textContent=countdown.hidden?'◷':'×';
            });
          }
        }
      }
      const delay=countdown?Math.min(remaining,1000):Math.min(remaining,2147483647);
      banner.dataset.vrPromotionTimer=String(setTimeout(updateVitaRenewPromotions,delay));
    });
  }
  updateVitaRenewPromotions();
  document.addEventListener('shopify:section:load',updateVitaRenewPromotions);
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)updateVitaRenewPromotions()});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vr-psp-blue-offer"] && !Shopify.designMode) return;
  try {
    
  function expirePspOffers(){
    document.querySelectorAll('[data-psp-offer-end]').forEach(banner=>{
      const remaining=Date.parse(banner.dataset.pspOfferEnd)-Date.now();
      if(remaining<=0)banner.remove();
      else setTimeout(expirePspOffers,Math.min(remaining,2147483647));
    });
  }
  expirePspOffers();
  document.addEventListener('shopify:section:load',expirePspOffers);
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)expirePspOffers()});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vr-refurbishment"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    const button = event.target.closest('.vr-refurb__close');
    if (!button) return;
    const panel = button.closest('details');
    const summary = panel.querySelector('summary');
    panel.open = false;
    summary.focus({preventScroll: true});
    const bounds = summary.getBoundingClientRect();
    if (bounds.top < 100 || bounds.bottom > window.innerHeight) {
      summary.scrollIntoView({block: 'center', behavior: 'instant'});
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vr-store-reviews"] && !Shopify.designMode) return;
  try {
    
  function initializeVitaRenewReviewCards() {
    document.querySelectorAll('.vr-store-reviews').forEach(section => {
      if (section.dataset.vrAccessibleCards) return;
      section.dataset.vrAccessibleCards = 'true';
      const initialized = new WeakSet();
      const visibility = new IntersectionObserver(entries => {
        entries.forEach(entry => { entry.target.tabIndex = entry.intersectionRatio >= 0.6 ? 0 : -1; });
      }, { threshold: [0, 0.6, 1] });
      const enhance = () => section.querySelectorAll('.jdgm-card').forEach(card => {
        if (initialized.has(card)) return;
        initialized.add(card);
        card.setAttribute('role', 'button');
        const name = card.querySelector('.jdgm-reviewer-name')?.textContent.trim() || '';
        const label = document.documentElement.lang.startsWith('de') ? 'Vollständige Bewertung lesen' : 'Read full review';
        card.setAttribute('aria-label', name ? label + ': ' + name : label);
        card.tabIndex = -1;
        card.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); card.click(); }
        });
        visibility.observe(card);
      });
      enhance();
      new MutationObserver(enhance).observe(section, { childList: true, subtree: true });
    });
  }
  initializeVitaRenewReviewCards();
  document.addEventListener('shopify:section:load', initializeVitaRenewReviewCards);
  (() => {
    const enhanceGoogleDialog = () => {
      const section = document.querySelector('.vr-store-reviews');
      const sourceLink = section?.querySelector('.vr-store-reviews__google-action .vr-google-reviews-link');
      if (!sourceLink) return;
      const reviewIds = new Set(Array.from(section.querySelectorAll('.jdgm-card[data-review-id]'), card => card.dataset.reviewId));
      document.querySelectorAll('.jdgm-modal__content .jm-review-item[review-uuid]').forEach(item => {
        if (!reviewIds.has(item.getAttribute('review-uuid'))) return;
        const badge = item.querySelector('.jm-transparency-badge-list')?.textContent || '';
        const destination = item.querySelector('.jm-product-variant-card__product-link')?.textContent.trim();
        if (!badge.includes('Google') || destination !== 'VitaRenew') return;
        item.dataset.vrGoogleSource = 'true';
        if (!item.querySelector(':scope > .vr-google-reviews-link')) item.append(sourceLink.cloneNode(true));
      });
    };
    let pending = false;
    new MutationObserver(changes => {
      if (pending || !changes.some(change => Array.from(change.addedNodes).some(node => node.nodeType === 1 && (node.matches('.jdgm-modal, .jdgm-modal__content, .jm-review-item') || node.closest('.jdgm-modal__content') || node.querySelector('.jdgm-modal__content'))))) return;
      pending = true;
      requestAnimationFrame(() => { pending = false; enhanceGoogleDialog(); });
    }).observe(document.body, { childList: true, subtree: true });
    enhanceGoogleDialog();
  })();

  } catch(e) { console.error(e); }
})();
})();
